module.exports = __webpack_public_path__ + "img/11.f531bbb0.png";